export enum StaffDepartmentEnum {
    FINANCE = 'finance',
    OPERATIONS = 'operations',
    MARKETING = 'marketing',
    SALES = 'sales',
    HR = 'hr',
    ADMIN = 'admin',
    TECH = 'tech',
  }